import {
    Box,
    Button,
    CloseButton,
    HStack,
    useDisclosure,
    Heading,
    Spacer,
    Stack,
    useToast,
    IconButton,
} from '@chakra-ui/react'
import { Select } from 'chakra-react-select'
import parse from 'html-react-parser'
import { useContext, useState } from 'react'
import { Rnd } from 'react-rnd'

import { FacilityContext } from './FacilityItems/index.jsx'
import clipboardCopy from 'clipboard-copy'
import { MdContentCopy } from 'react-icons/md'

export const SalesTalks = () => {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const [selectedIndex, setSelectedIndex] = useState(0)
    const data = useContext(FacilityContext)

    const SalesTalkCopy = data.salesTalks?.length ? [...data.salesTalks] : []
    //セールストークを更新日(新しい順)でソート
    if (SalesTalkCopy.length) {
        SalesTalkCopy.sort((a, b) =>
            a?.salesTalkDate > b?.salesTalkDate ? -1 : 1
        )
    }

    const options = SalesTalkCopy?.map((_, index) => ({
        label: SalesTalkCopy[index]?.salesTalkTitle
            ? SalesTalkCopy[index]?.salesTalkTitle
            : `セールストーク${index + 1}`,
        value: index,
    }))

    const close = () => {
        setSelectedIndex(0)
        onClose()
    }

    const chakraStyles = {
        container: (provided) => ({
            ...provided,
            cursor: 'pointer',
        }),
        option: (provided, state) => ({
            ...provided,
            cursor: state.isSelected ? 'default' : 'pointer',
        }),
    }

    if (data?.salesTalks?.length) {
        return (
            <>
                <Button
                    onClick={() => {
                        isOpen ? close() : onOpen()
                    }}
                >
                    セールストーク
                </Button>
                {isOpen && (
                    <Rnd
                        default={{
                            x: -267,
                            y: 50,
                            width: 400,
                            height: 400,
                        }}
                        minWidth={250} // 最小幅
                        minHeight={150} // 最小高さ
                        cancel=".no-drag"
                        style={{
                            boxShadow: 'rgb(144 164 174 / 25%) 0px 0px 8px 0px',
                            borderRadius: '10px',
                            background: '#ffffff',
                            position: 'fixed',
                            zIndex: 1000,
                            overflow: 'hidden',
                        }}
                    >
                        <HStack bg="tryt.pale-1" p="16px 12px">
                            <Heading size="md" color="tryt.primary-1">
                                セールストーク
                            </Heading>
                            <Spacer />
                            <CloseButton onClick={close} />
                        </HStack>

                        <Box className="no-drag" m="8px 12px">
                            <Select
                                options={options}
                                chakraStyles={chakraStyles}
                                onChange={(selectedOption) =>
                                    setSelectedIndex(selectedOption?.value)
                                }
                                defaultValue={options[0]}
                            />
                        </Box>
                        <Box
                            overflowY="auto"
                            overflowX="auto"
                            h="calc(100% - 122px)"
                        >
                            {selectedIndex !== null && (
                                <Box fontWeight="bold" padding="20px 20px">
                                    <HStack alignItems="flex-start">
                                        <Box
                                            flex={1}
                                            userSelect="text"
                                            cursor="text"
                                            className="no-drag"
                                        >
                                            {/* セールストークの内容 */}
                                            {parse(
                                                SalesTalkCopy[selectedIndex]
                                                    ?.salesTalkPoint
                                            )}
                                        </Box>
                                        {/* セールストークのコピーボタン */}
                                        <CopySalesTalkButton
                                            salesTalkPoint={
                                                SalesTalkCopy[selectedIndex]
                                                    ?.salesTalkPoint
                                            }
                                        />
                                    </HStack>
                                </Box>
                            )}
                        </Box>
                    </Rnd>
                )}
            </>
        )
    }
    return null
}

export const CopySalesTalkButton = ({ salesTalkPoint }) => {
    const toast = useToast()
    const onClick = async () => {
        const replacedHtml = salesTalkPoint
            .replace(/<\/p>\s*/gi, '\n')
            .replace(/<p[^>]*>/gi, '')

        const tempElement = document.createElement('div')
        tempElement.innerHTML = replacedHtml
        const plainText = tempElement.textContent || tempElement.innerText || ''

        await clipboardCopy(plainText)

        toast({
            title: 'セールストークをコピーしました',
            status: 'success',
            duration: 3000,
            isClosable: true,
            containerStyle: {
                marginTop: 'calc(100vh / 2 - 50px)',
            },
        })
    }

    return (
        <IconButton
            size="sm"
            aria-label="copy"
            icon={<MdContentCopy />}
            onClick={onClick}
        />
    )
}
